module.exports = __webpack_public_path__ + "static/media/stofferingen-18.7e10c409.jpg";